
export { default as GitaFestival26 } from './impl/GitaFestival26.jsx';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/GitaFestival26/index.jsx